import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import { CheckboxFilters } from 'constants/filters';
import FilterCheckboxesBlock from 'components/FilterCheckboxesBlock';
import { CheckboxesBlocksWrapper } from './styles';

function FilterCheckboxesBlocks() {
  var checkboxesBlocks = Object.keys(CheckboxFilters);
  return /*#__PURE__*/_jsx(CheckboxesBlocksWrapper, {}, void 0, checkboxesBlocks.map(function (block) {
    var blockItems = Object.keys(CheckboxFilters[block]);
    return /*#__PURE__*/_jsx(FilterCheckboxesBlock, {
      blockItems: blockItems,
      block: block
    }, block);
  }));
}

export default FilterCheckboxesBlocks;